// eslint-disable-next-line @typescript-eslint/typedef
export const FragmentParserEvents = {
  fragments: {
    fragmentsParsed: 'fragmentParser.fragments.fragmentsParsed',
    videoFragmentParsed: 'fragmentParser.fragments.videoFragmentParsed',
    audioFragmentParsed: 'fragmentParser.fragments.audioFragmentParsed',
  },
};

export interface IFragmentsParsedPayload {
  data: Uint8Array;
  initSegment: Uint8Array;
  independent: boolean;
}
